import React, { memo } from 'react';
import playerRowStyles from './TablePlayerRow.module.css';
import rankingTabStyles from '../TournamentRankingTab.module.css';
import { styled } from 'styled-components';
import Flexbox from '../../../../../../../../shared/components/Flexbox';
import { useTranslation } from 'react-i18next';
import { formatNumberWithSpaces } from 'shared/utils/helpers';

interface LeaderboardEntry {
  score: {
    position: number;
    playerId: string;
    playerName: string;
    score: number;
    isCurrentPlayer?: boolean;
  };
}

const PositionBadge = styled.div<{ $position: number }>`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${(props) =>
    props.$position === 1
      ? '#FFD700'
      : props.$position === 2
      ? '#C0C0C0'
      : props.$position === 3
      ? '#CD7F32'
      : 'rgba(255, 255, 255, 0.1)'};
  border-radius: 8px;
  color: ${(props) => (props.$position > 3 ? 'rgba(255, 255, 255, 0.8)' : '#1c1c1e')};
  font-family: var(--font-family-primary);
  font-weight: 500;
  font-size: 24px;
  line-height: normal;
  width: ${(props) => (props.$position > 99 ? 'auto' : '30px')};
  padding: ${(props) => (props.$position > 99 ? '0px 4px' : '0px')};
  height: 30px;

  @media (max-width: 1024px), ((min-width: 768px) and (max-width: 1024px) and (orientation: landscape)), (orientation: portrait) {
    border-radius: 5px;
    font-size: 16px;
    width: ${(props) => (props.$position > 99 ? 'auto' : '20px')};
    height: 20px;
  }
`;

const TablePlayerRow: React.FC<LeaderboardEntry> = ({ score }) => {
  const { t } = useTranslation();
  return (
    <tr
      className={`${rankingTabStyles['tableRow']} ${playerRowStyles['tablePlayerRow']}`}
      data-is-current-position={score.isCurrentPlayer || false}
      key={score.position}
    >
      <td className={playerRowStyles['tableCell']}>
        <Flexbox $width={score.position > 99 ? 'auto' : '30px'} $justify="center">
          <PositionBadge $position={score.position}>{score.position}</PositionBadge>
        </Flexbox>
        <div className={playerRowStyles['playerName']}>
          {score.isCurrentPlayer ? t('generic_you').toUpperCase() : score.playerName}
        </div>
      </td>
      <td className={playerRowStyles['scoreCell']}>
        <span className={playerRowStyles['scoreRow']}>{formatNumberWithSpaces(score.score.toString())}</span>
      </td>
    </tr>
  );
};
export default memo(TablePlayerRow);
